"use client";
import { useContext, useEffect, useRef, useCallback } from "react";
import Draggable from "react-draggable";
import { AppContext } from "./AppContext";
import AnalyzerDots from "./AnalyzerDots";
import { deepCopy } from "@/functions/fns";

/* const Spreads = ({ s, top, left }) => {
  let { start, end } = s;
  return [start, end].map((val, w) => {
    val = parseInt(val);
    const st = { top, left, width: val + "%", margin: val * -0.5 + "%" };
    return (
      <div
        key={w}
        style={st}
        className="pointer-events-none absolute aspect-square rounded-full border border-black"
      ></div>
    );
  });
}; */

export default function Analyzer({ prevContainer }) {
	const { openLeaf, setColorHilight, setConfig, config } =
		useContext(AppContext);
	const cl = useCallback(
		(n) => {
			return n === openLeaf
				? {
						c: "ring-white z-[999]",
						b: "white",
				  }
				: {
						c: "ring-white/50",
						b: "rgba(255,255,255,.3)",
				  };
		},
		[openLeaf]
	);

	const cnt = config.map((c, i) => {
		const { x, y, colors } = c;
		return colors.map((o, k) => {
			return x[k] && y[k] ? (
				<Draggable
					key={i + "-" + k}
					position={{ x: +x[k], y: +y[k] }}
					onDrag={(e) => {
						let { clientX, clientY } = e;
						let {
							left: parentL,
							top: parentT,
							width: parentW,
							height: parentH,
						} = getSize();
						clientX = clientX - parentL;
						clientY = clientY - parentT;
						/* parentW = parentW - parentL
                    parentH = parentH - parentT */
						let y = (clientY * 100) / parentH;
						let x = (clientX * 100) / parentW;
						//x = x > 100 ? 100 : x < 0 ? 0 : x;
						//y = y > 100 ? 100 : y < 0 ? 0 : y;
						const newConfig = deepCopy(config);
						newConfig[i].x[k] = parseInt(x) + "%";
						newConfig[i].y[k] = parseInt(y) + "%";
						setConfig(newConfig);
					}}
					onStart={() => setColorHilight([i, k])}
				>
					<div>
						<div
							className={
								cl(i).c +
								" absolute -m-[6px] h-[12px] w-[12px] cursor-move rounded-full ring-4"
							}
							style={{
								backgroundColor: o,
								top: y[k],
								left: x[k],
							}}
						/>
						{/* <Spreads s={spread[k]} top={y[k]} left={x[k]} /> */}
					</div>
				</Draggable>
			) : null;
		});
	});

	const canvasRef = useRef(null);

	useEffect(() => {
		const getCord = (v, what) => {
			v = parseInt(v);
			const w = prevContainer.current.getBoundingClientRect()[what];
			return (w * v) / 100;
		};

		if (canvasRef.current) {
			const c = canvasRef.current;
			const ctx = c.getContext("2d");
			ctx.clearRect(0, 0, c.width, c.height);
			config.forEach((u, uu) => {
				const { x, y } = deepCopy(u);

				if (x.length > 0) {
					const startX = getCord(x[0], "width");
					const startY = getCord(y[0], "height");
					x.shift();
					y.shift();
					ctx.beginPath();
					ctx.moveTo(startX, startY);
					x.forEach((s, l) => {
						ctx.lineTo(
							getCord(s, "width"),
							getCord(y[l], "height")
						);
					});
				}
				ctx.lineWidth = 2;
				ctx.lineCap = "round";
				ctx.lineJoin = "round";
				ctx.strokeStyle = cl(uu).b;
				ctx.setLineDash([1, 10]);
				ctx.stroke();
			});
		}
	}, [canvasRef, config, prevContainer, openLeaf, cl]);

	const getSize = () => {
		return prevContainer.current.getBoundingClientRect();
	};

	return (
		<div className="absolute inset-0">
			<AnalyzerDots />
			<div className="absolute inset-0 z-50">{cnt}</div>
			<canvas
				height={getSize().height}
				width={getSize().width}
				className="pointer-events-none absolute inset-0 z-50"
				ref={canvasRef}
			/>
		</div>
	);
}
